import React from 'react';
import { useNavigate } from 'react-router-dom';
import { MegaphoneIcon, SparklesIcon } from '@heroicons/react/24/outline';

const PublicListingsDashboardQuickAction: React.FC = () => {
  const navigate = useNavigate();

  return (
    <button
      onClick={() => navigate('/landlord-dashboard')}
      className="w-full group flex items-center justify-between p-4 sm:p-6 bg-white border border-gray-200 rounded-xl sm:rounded-2xl shadow-sm hover:shadow-md hover:border-indigo-500 transition-all duration-200 text-left"
    >
      <div className="flex items-center gap-4 sm:gap-5">
        <div className="p-3 sm:p-4 bg-indigo-50 text-indigo-600 rounded-lg sm:rounded-xl group-hover:bg-indigo-100 transition-colors">
          <MegaphoneIcon className="w-6 h-6 sm:w-8 sm:h-8" />
        </div>
        <div>
          <h3 className="text-lg sm:text-xl font-bold text-gray-900 mb-1">
            Manage Public Listings
          </h3>
          <p className="text-gray-500 text-sm sm:text-base leading-snug sm:leading-relaxed">
            Curate your public listing dashboard and attract new tenants.
          </p>
          <p className="mt-1 text-xs sm:text-sm text-indigo-600 flex items-center gap-1 font-medium">
            <SparklesIcon className="w-4 h-4" />
            These are for listings visible to everyone.
          </p>
        </div>
      </div>
      <div className="hidden sm:flex bg-indigo-600 text-white rounded-full p-2 ml-4 group-hover:bg-indigo-700 transition-colors">
        <MegaphoneIcon className="w-6 h-6" />
      </div>
    </button>
  );
};

export default PublicListingsDashboardQuickAction;
